// Func = limiting Scope for this file
var lastScrollTop = 0;
if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
(function(){

	$(document).ready(function () {
		$( ".intro .btn" ).each(function( index ) {
			$(this).addClass('animate');
		  });
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
		$('.sym-slides').slick({
			accessibility: false
		});
		$(".menu-modal-trigger").click(function(){
			$(".modal-dialog").addClass("open");
		});
		$(".close").click(function(){
			$(".modal-dialog").removeClass("open");
		});
		$(".js-widget,.js-booking-close").click(function(){
			$("#bookingBox").toggleClass("open");
			return false;
		});

		$(".masthead-item-video-pause").click(function(){
			$(".masthead-item-video-pause").toggleClass("paused");
			if($(this).hasClass('paused')) {
				document.getElementById("videoContainer_63069555cdd40").pause();
			} else {
				document.getElementById("videoContainer_63069555cdd40").play();

			}
		});
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 50){
		if(!document.getElementById('fixed-button').classList.contains('in')){
			document.getElementById('fixed-button').classList.add('in');
		}
	} else {
		if(document.getElementById('fixed-button').classList.contains('in')){
			document.getElementById('fixed-button').classList.remove('in');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
			animatedEl[i].classList.remove('fade-out');
		} else {

			animatedEl[i].classList.remove('fade-in');
			animatedEl[i].classList.add('fade-out');
		}
		// if(topPos >= window_height*0.90){
		// 	animatedEl[i].classList.remove('fade-in');
		// 	animatedEl[i].classList.add('fade-out');
		// }
	}

}